import { Download, X } from 'lucide-react';
import { usePWAInstall } from '@/hooks/usePWAInstall';

export default function InstallPWAButton() {
  const { isInstallable, isInstalled, install } = usePWAInstall();

  if (isInstalled || !isInstallable) return null;

  return (
    <div className="fixed bottom-6 left-6 z-50 animate-in slide-in-from-bottom-5 fade-in duration-300">
      <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 p-4 max-w-sm">
        <div className="flex items-start gap-3">
          <div className="w-20 h-20 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
            <img src="/logo-waigh-transparent.png" alt="Target Express" className="w-16 h-16 object-contain" />
          </div>
          <div className="flex-1">
            <h3 className="font-bold text-gray-900 mb-1">تثبيت التطبيق</h3>
            <p className="text-sm text-gray-600 mb-3">
              ثبّت Target Express على جهازك للوصول السريع
            </p>
            <div className="flex gap-2">
              <button
                onClick={install}
                className="flex-1 bg-orange-600 hover:bg-orange-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
              >
                <Download className="w-4 h-4" />
                تثبيت
              </button>
              <button
                onClick={() => {
                  const el = document.querySelector('.fixed.bottom-6.left-6');
                  el?.remove();
                }}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <X className="w-4 h-4 text-gray-500" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
